module.exports = __webpack_public_path__ + "media/images/common/ico-ramen-header-399eaa74d077eb6d3cbf021c38044eb4.svg";